@if (showTable()) {
  <div class="example-container position-relative mat-elevation-z8 table-width">
    <table
      mat-table
      [dataSource]="transposedData()"
      class="styled-table"
      aria-label="Blower parameters table showing parameter name, unit and model values">
      <!-- Headers -->
      <ng-container matColumnDef="header-label">
        <th mat-header-cell *matHeaderCellDef class="bg-primary value-column-narrow2">Parameters</th>
      </ng-container>
      <ng-container matColumnDef="header-unit">
        <th mat-header-cell *matHeaderCellDef class="bg-primary value-column-narrow">Unit</th>
      </ng-container>
      <ng-container matColumnDef="header-value">
        <th mat-header-cell *matHeaderCellDef class="bg-primary value-header-cell">Model : {{ modelName || 'Result' }}</th>
      </ng-container>
      <!-- Label Column -->
      <ng-container matColumnDef="label">
        <td mat-cell *matCellDef="let row" class="label-cell">
          {{ row.label }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="label-cell fw-bold">Download</td>
      </ng-container>
      <!-- Unit Column -->
      <ng-container matColumnDef="unit">
        <td mat-cell *matCellDef="let row" class="unit-cell">
          {{ row.unit }}
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <td mat-cell *matCellDef="let row" class="value-cell">
          <div class="value-with-warning">
            <span class="value-text">{{ row.col0 }}</span>
            <span class="warning-inline">
              @if (row.label === 'MODEL' && row.isStalling) {
                <span class="warning-message">Turbo stalling?</span>
                <span class="warning-message">Bleed Air={{ getBleedAirText(row) }}</span>
              }
              @if (row.label === 'Rotation Speed' && isMotorSpeedTooHigh(row)) {
                <span class="warning-message">Motor speed too high</span>
              }
              @if (row.label === 'Shaft Torque' && isShaftTorqueHigh(row)) {
                <span class="warning-message">Motor torque above nominal</span>
              }
            </span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="value-cell footer-download-cell">
          <button type="button" class="download-link" (click)="downloadPdf()">
            <img src="../../../../assets/img/download.svg" alt="Download PDF" class="icon" />
            <span class="link-text"> PDF</span>
          </button>
        </td>
      </ng-container>
      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="['header-label', 'header-unit', 'header-value']"></tr>
      <!-- Data Rows -->
      <tr mat-row *matRowDef="let row; columns: ['label', 'unit', 'value']" class="row-height"></tr>
      <!-- Footer Row -->
      <tr mat-footer-row *matFooterRowDef="['label', 'unit', 'value']" class="row-height"></tr>
    </table>
  </div>
}

<!-- Inline calculating state shown while waiting for backend results -->
@if (isCalculating()) {
  <div class="calculating-state" aria-live="polite" aria-label="Calculating results">
    <div class="calculating-spinner" aria-hidden="true"></div>
    <div class="calculating-message">Calculating results...</div>
  </div>
}

<!-- PDF download toast (fixed at bottom) -->
@if (isPdfDownloading()) {
  <div class="pdf-download-toast" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <div class="pdf-message">PDF is being downloaded...</div>
  </div>
}
